<template>
	<div>
		<changeNav />
		<Carousel>
			<template slot="titleTxt">
				<div class="title-box">
					<img src="~@/assets/image/join_us.png" alt="" width="95" height="23" class="title-img" />
					<span class="title-txt">Join US</span>
				</div>
			</template>
		</Carousel>
		<Breadcrumb />
		<!--招聘职位-->
		<section>
			<div class="join_container">
				<h2>招聘职位</h2>
				<div class="recr_position">
					<ul class="recr_wrap clearfix">
						<li class="recr_item  clearfix" v-for="(item,index) in joinPositon" :key="index" @click="goPositionDetail(item.id)">
							<div class="recr_left">
								<div class="recr_postion">{{item.positionTitle}}</div>
								<div class="postion_info">工作地点：<span>{{item.location}}</span> / 招聘人数：<span>{{item.recruitNum}}</span>人</div>
							</div>
							<div class="join_detail">
								<el-button round>了解详情</el-button>
							</div>
						</li>
					</ul>
				</div>
				<!--<div class="more"><el-button round class="roundbtn">MORE ></el-button></div>-->
			</div>
		</section>
		<!--招聘职位结束-->
		<!--员工活动-->
		<section class="active_bg">
			<div class="join_container">
				<h2>员工活动</h2>
				<div class="activities">
					<ul class="activities_container clearfix">
						<li v-for="(item,index) in activities" :key="index">
							<div class="active_img">
								<img :src="item.imageUrl" width="400" height="250" alt="" />
							</div>
							<div class="active_info">
								<div cl class="active_name">{{item.title}}</div>
								<div class="active_brief">
									{{item.content}}
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</section>
		<!--员工活动结束-->
		<!---办公环境-->
		<!-- <section class="environment_bg">
			<div class="join_container">
				<h2>办公环境</h2>
				<div class="environment">
					<span class="arrow-left" @click="prev"></span>
					<el-carousel :interval="40000000" type="card" height="370px" indicator-position="none" arrow="never" ref="Evcarousel">
						<el-carousel-item v-for="(item,index) in environments" :key="index">
							<h3 class="medium">
								<div class="img_container">
									<img :src="item.imageUrl" width="490" height="331" alt="" />
								</div>
								<span class="text">{{item.title}}</span>
							</h3>
						</el-carousel-item>
					</el-carousel>
					<span class="arrow-right" @click="next"></span>
				</div>
			</div>
		</section> -->
		<!---办公环境结束-->
	</div>
</template>

<script>
	// export default {
	//     name: "JoinUsPart"
	// }
	import changeNav from '@/components/changeNav.vue';
	import Carousel from '@/components/Carousel.vue';
	import Breadcrumb from '@/components/Breadcrumb.vue';
	import {
		GetJoinUs
	} from '../Home/Home.model';
	import {
		GetStaffActivities,
		GetOfficeEnvironment
	} from './JoinUsPart.model';
	export default {
		name: "JoinUsPart",
		components: {
			changeNav,
			Carousel,
			Breadcrumb
		},
		metaInfo: {
			title: '福建省越盛智能科技有限公司', // set a title
			meta: [{ // set meta
				name: '越盛智能、全自动智能布料小车、无功补偿、无人值守智能称重、视觉智能检测、能源在线监测、智能配料、自动喂料系统、自动喂养系统、智能饲养系统、养猪场喂料设备、养鸡场自动喂料系统、自动化养殖设备、智能喂养系统、智能称重喂养系统、自动称重喂养设备',
				content: '加入我们'
			}],
			link: [{ // set link
				rel: 'asstes',
				href: 'http://www.fjyszn.com/'
			}]
		},
		data() {
			return {
				joinPositon: [],
				activities: [],
				environments: []
			}
		},
		async mounted() {
			this.srollToTotp();
			let params = {
				page: 1,
				limit: 0
			}
			let joinlist = await GetJoinUs(params);
			this.joinPositon = joinlist.data.list;

			let activList = await GetStaffActivities();
			this.activities = activList.data.list;

			let environmentData = await GetOfficeEnvironment();
			this.environments = environmentData.data.list;
		},
		methods: {
			prev() {
				this.$refs.Evcarousel.prev();
			},
			next() {
				this.$refs.Evcarousel.next();
			},
			goPositionDetail(posId) {
				this.$router.push({
					path: "/JobDetail",
					query: {
						posId: posId
					}
				});
			},
			srollToTotp() {
				window.pageYOffset ? window.pageYOffset = 0 : document.documentElement.scrollTop ? document.documentElement.scrollTop =
					0 : document.body.scrollTop ? document.body.scrollTop = 0 : null;
			}
		}
	}
</script>

<style scoped lang="less">
	.title-box {
		text-align: left;
		height: 80px;
		line-height: 80px;

		img {
			vertical-align: middle;
		}

		span {
			vertical-align: middle;
			color: #CCC;
			font-size: 16px;
			display: inline-block;
			margin-left: 15px;
			line-height: 24px;
			margin-top: 10px;
		}
	}

	.join_container {
		width: 1240px;
		margin: 20px auto 0px;

		h2 {
			width: 100%;
			text-align: center;
			color: #333;
			height: 80px;
			line-height: 80px;
			font-size: 24px;
			margin: 20px 0px;
		}
	}

	/*招聘*/
	.recr_position {
		.recr_wrap {}

		.recr_item {
			width: 610px;
			height: 111px;
			background: rgba(255, 255, 255, 1);
			border: 1px solid #E6E6E6;
			float: left;
			padding: 30px;
			box-sizing: border-box;
			margin-bottom: 30px;
			transition: all .25s ease-in;
			-moz-transition: all .25s ease-in;
			-webkit-transition: all .25s ease-in;

			&:hover {
				cursor: pointer;
				border: none;
				box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
				transform: translateY(-10px);

				.join_detail {
					.el-button {
						cursor: pointer;
						background: linear-gradient(45deg, rgba(40, 165, 231, 1) 0%, rgba(107, 218, 252, 1) 100%);
						box-shadow: 0px 9px 14px -8px rgba(57, 178, 236, 0.6);
						border-radius: 17px;
						color: #fff;
						border: none;
					}
				}


			}

			&:nth-child(2n) {
				margin-left: 20px;
			}

			.recr_left {
				float: left;
			}

			.recr_postion {
				text-align: left;
				font-size: 18px;
				font-weight: 600;
				color: rgba(51, 51, 51, 1);
				line-height: 22px;

			}

			.postion_info {
				text-align: left;
				height: 17px;
				font-weight: 400;
				color: rgba(128, 128, 128, 1);
				line-height: 17px;
				margin-top: 15px;
			}

			.join_detail {
				float: right;

				.el-button {
					width: 102px;
					height: 34px;
					border-radius: 17px;
					border: 1px solid rgba(230, 230, 230, 1);
					font-size: 14px;
					line-height: 8px;
					color: #B3B3B3;
					margin-top: 8px;

					&:hover {
						cursor: pointer;
						background: linear-gradient(45deg, rgba(40, 165, 231, 1) 0%, rgba(107, 218, 252, 1) 100%);
						box-shadow: 0px 9px 14px -8px rgba(57, 178, 236, 0.6);
						border-radius: 17px;
						color: #fff;
						border: none;
					}
				}
			}
		}
	}

	/*活动*/
	.active_bg {
		background: #F2F2F2;
		padding-bottom: 40px;

		.join_container {
			h2 {
				padding-top: 27px;
				padding-bottom: 6px;
			}
		}
	}

	.activities {
		.activities_container {
			.active_img {}
			.active_info {
				padding: 12px;
			}
			.active_name {
				color: #ccc;
				font-size: 16px;
				font-weight: 500;
				color: rgba(51, 51, 51, 1);
				line-height: 22px;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
			}

			.active_brief {
				font-size: 14px;
				margin-top: 8px;
				font-weight: 400;
				color: rgba(153, 153, 153, 1);
				line-height: 24px;
				-webkit-line-clamp: 2;
				/*用来限制在一个块元素显示的文本的行数*/
				display: -webkit-box;
				/*必须结合的属性，将对象作为弹性伸缩盒子模型显示*/
				-webkit-box-orient: vertical;
				/*必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式*/
				overflow: hidden;
				word-break: break-all;
			}
		}

		li {
			background-color: #fff;
			width: 400px;
			height: 365px;
			background: rgba(255, 255, 255, 1);
			float: left;
			margin-right: 20px;
			text-align: left;
			margin-bottom: 40px;

			&:nth-child(3n) {
				margin-right: 0px;
			}
		}
	}

	/*环境*/
	.environment_bg {
		height: 610px;
		background-color: #fff;
	}

	.environment {
		position: relative;

		.arrow-left {
			position: absolute;
			left: -40px;
			top: 50%;
			margin-top: -37px;
			display: inline-block;
			width: 22px;
			height: 37px;
			background: url("~@/assets/image/arrow-left.png") no-repeat center center;
			background-size: contain;

			&:hover {
				background: url("~@/assets/image/arrow-left-focus.png") no-repeat center center;
				background-size: contain;
			}
		}

		.arrow-right {
			position: absolute;
			right: -40px;
			top: 50%;
			margin-top: -37px;
			z-index: 99999999999999999999999999;
			width: 22px;
			height: 37px;
			display: inline-block;
			background: url("~@/assets//image/arrow-right.png") no-repeat center center;
			background-size: contain;

			&:hover {
				background: url("~@/assets/image/arrow-right-focus.png") no-repeat center center;
				background-size: contain;
			}
		}
	}

	.el-carousel__item h3 {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 200px;
		margin: 0;
	}


	.medium {
		height: 100%;
		width: 620px;
		top: 50%;
		background-color: #fff;
		opacity: 1;

		img {
			width: 100%;
			opacity: 1 !important;
		}

		.text {
			display: block;
			font-size: 16px;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
			line-height: 22px;
			margin-top: 10px;
		}
	}

	.el-carousel__item {
		h3 {
			line-height: 20px;
			color: #000000;
		}
	}

	.el-carousel__mask {
		border: 1px solid green;
	}

	.is-active {
		.text {
			font-size: 20px;
			color: #fff;
			font-weight: 500;
			color: rgba(51, 51, 51, 1);
			line-height: 24px;
		}

		.medium {
			width: 620px !important;
		}
	}

	.more {
		margin: 20px auto 70px;

		.roundbtn {
			width: 135px;
			height: 42px;
			border-radius: 21px;
			border: 1px solid rgba(204, 204, 204, 1);

			&:hover {
				cursor: pointer;
				background: linear-gradient(45deg, rgba(40, 165, 231, 1) 0%, rgba(107, 218, 252, 1) 100%);
				box-shadow: 0px 9px 14px -8px rgba(57, 178, 236, 0.6);
				border-radius: 21px;
				color: #fff;
				border: none;
			}
		}
	}


	.el-carousel__item h3 {
		opacity: 1;
		text-align: center;

		.img_container {
			background: #fff;
		}
	}

	.el-carousel__item:nth-child(2n) h3 {
		background: #fff;

	}

	.el-carousel__item:nth-child(2n+1) h3 {
		background: #fff;
	}

	.el-carousel__item.is-active h3 {
		text-align: center !important;
	}
</style>
